
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const getIcon = (severity?: string) => {
      switch (severity) {
        case "success":
          return "pi pi-check-circle";
        case "info":
          return "pi pi-info-circle";
        case "warn":
          return "pi pi-exclamation-triangle";
        case "error":
          return "pi pi-times-circle";
        default:
          return "pi pi-info-circle";
      }
    };

    return { getIcon };
  },
  props: {
    group: { type: String, default: "top-right" }
  },
  components: {}
});
